"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownToolbar = void 0;
var react_1 = __importStar(require("react"));
var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var useTheme_1 = __importDefault(require("@material-ui/core/styles/useTheme"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var Menu_1 = __importDefault(require("@material-ui/core/Menu"));
var ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
var clsx_1 = __importDefault(require("clsx"));
var Drawer_1 = require("../Drawer");
var prop_types_1 = __importDefault(require("prop-types"));
var useStyles = makeStyles_1.default(function (theme) {
    var _a;
    return createStyles_1.default({
        root: (_a = {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                minHeight: "4rem"
            },
            _a[theme.breakpoints.down('xs')] = {
                minHeight: "3.5rem",
            },
            _a),
        navigation: {
            marginRight: theme.spacing(2),
            width: '2.5rem',
            height: '2.5rem',
            alignItems: 'center',
            justifyContent: 'flex-start',
            display: 'flex',
        },
        navGroups: {
            '&:active, &:focus': {
                outline: 'none',
            },
        },
        textContent: {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            // set margins to default to avoid the height of the app bar exceeding 56px on mobile
            '&.MuiListItemText-multiline': {
                marginTop: '0.25rem',
                marginBottom: '0.25rem',
            },
        },
        title: {
            lineHeight: 1.2,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
        subtitleContent: {
            display: 'flex',
            flexDirection: 'row',
            maxWidth: 'fit-content',
            marginTop: '-0.125rem',
        },
        cursorPointer: {
            cursor: 'pointer',
        },
        subtitle: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        dropdownArrow: {
            marginLeft: theme.spacing(0.5),
        },
        rotateDropdownArrow: {
            transform: 'rotate(180deg)',
        },
    });
});
var DropdownToolbarRender = function (props, ref) {
    var title = props.title, subtitle = props.subtitle, menuGroups = props.menuGroups, navigationIcon = props.navigationIcon, menu = props.menu, MenuProps = props.MenuProps, onClose = props.onClose, onOpen = props.onOpen, _a = props.classes, classes = _a === void 0 ? {} : _a, toolbarProps = __rest(props, ["title", "subtitle", "menuGroups", "navigationIcon", "menu", "MenuProps", "onClose", "onOpen", "classes"]);
    var _b = react_1.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var anchor = react_1.useRef(null);
    var theme = useTheme_1.default();
    var rtl = theme.direction === 'rtl';
    var defaultClasses = useStyles(theme);
    var getNavigationIcon = react_1.useCallback(function () {
        if (navigationIcon) {
            return react_1.default.createElement("div", { className: clsx_1.default(defaultClasses.navigation, classes.navigation) }, navigationIcon);
        }
    }, [navigationIcon, defaultClasses, classes]);
    var closeMenu = react_1.useCallback(function () {
        if (onClose) {
            onClose();
        }
        setAnchorEl(null);
    }, [onClose]);
    var openMenu = react_1.useCallback(function (event) {
        if (onOpen) {
            onOpen();
        }
        setAnchorEl(event);
    }, [onOpen]);
    react_1.useEffect(function () {
        for (var _i = 0, menuGroups_1 = menuGroups; _i < menuGroups_1.length; _i++) {
            var group = menuGroups_1[_i];
            var _loop_1 = function (item) {
                var onClick = item.onClick;
                if (onClick) {
                    item.onClick = function (e) {
                        onClick(e);
                        closeMenu();
                    };
                }
            };
            for (var _a = 0, _b = group.items; _a < _b.length; _a++) {
                var item = _b[_a];
                _loop_1(item);
            }
        }
    }, [menuGroups]);
    var getMenu = react_1.useCallback(function () {
        if (menu && Boolean(anchorEl)) {
            return react_1.default.cloneElement(menu, __assign({ anchorEl: anchorEl, open: Boolean(anchorEl), onClose: closeMenu }, menu.props));
        }
        if (menuGroups && Boolean(anchorEl)) {
            return (react_1.default.createElement(Menu_1.default, __assign({ getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: rtl ? 'right' : 'left' }, transformOrigin: { vertical: 'top', horizontal: rtl ? 'right' : 'left' }, anchorEl: anchorEl, open: Boolean(anchorEl), onClose: function () { return closeMenu(); } }, MenuProps, { MenuListProps: { style: { padding: 0 } } }), !menu &&
                menuGroups.map(function (group, index) { return (react_1.default.createElement("div", { className: defaultClasses.navGroups, key: index },
                    react_1.default.createElement(Drawer_1.DrawerNavGroup, { divider: false, hidePadding: true, itemIconColor: group.iconColor, itemFontColor: group.fontColor, title: group.title, items: group.items.map(function (item, itemIndex) {
                            return Object.assign({ itemID: itemIndex.toString() }, item);
                        }) }))); })));
        }
    }, [menuGroups, menu, anchorEl, MenuProps, defaultClasses]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Toolbar_1.default, { ref: ref, className: clsx_1.default(defaultClasses.root, classes.root), style: toolbarProps.style },
            getNavigationIcon(),
            react_1.default.createElement(ListItemText_1.default, { className: clsx_1.default(defaultClasses.textContent, classes.textContent), primary: react_1.default.createElement(Typography_1.default, { variant: "h6", className: clsx_1.default(defaultClasses.title, classes.title) }, title), secondary: react_1.default.createElement(Typography_1.default, { ref: anchor, "aria-haspopup": "true", component: 'div', onClick: function () {
                        openMenu(anchor.current);
                    }, className: clsx_1.default(defaultClasses.subtitleContent, classes.subtitleContent, menuGroups || menu ? defaultClasses.cursorPointer : '') },
                    react_1.default.createElement("span", { className: clsx_1.default(defaultClasses.subtitle, classes.subtitle) }, subtitle || ''),
                    (menuGroups || menu) && (react_1.default.createElement(ArrowDropDown_1.default, { className: clsx_1.default(defaultClasses.dropdownArrow, classes.dropdownArrow, anchorEl ? defaultClasses.rotateDropdownArrow : '') }))) }),
            props.children),
        getMenu()));
};
/**
 * [DropdownToolbar](https://brightlayer-ui-components.github.io/react/?path=/info/components-dropdown-toolbar--get-read-me-story) component
 *
 * The `<DropdownToolbar>` component is used to display a toolbar with a dropdown menu for a subtitle. The Menu can be populated via the `menuGroups` prop, or can be entirely customized by supplying your own `<Menu>` via the `menu` prop.
 */
exports.DropdownToolbar = react_1.default.forwardRef(DropdownToolbarRender);
exports.DropdownToolbar.displayName = 'DropdownToolbar';
exports.DropdownToolbar.propTypes = {
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
    }),
    menu: prop_types_1.default.element,
    title: prop_types_1.default.string,
    subtitle: prop_types_1.default.string,
    // @ts-ignore
    menuGroups: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        title: prop_types_1.default.string,
        fontColor: prop_types_1.default.string,
        iconColor: prop_types_1.default.string,
        items: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            icon: prop_types_1.default.element,
            onClick: prop_types_1.default.func,
            statusColor: prop_types_1.default.string,
            subtitle: prop_types_1.default.string,
            title: prop_types_1.default.string,
            divider: prop_types_1.default.bool,
        })),
    })),
    MenuProps: prop_types_1.default.object,
    onClose: prop_types_1.default.func,
    onOpen: prop_types_1.default.func,
};
exports.DropdownToolbar.defaultProps = {
    classes: {},
    menuGroups: [],
    MenuProps: {},
    onClose: function () { },
    onOpen: function () { },
};
